import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';

import { toBoolean } from '../util/convert';
import { NzRadioGroupComponent } from './nz-radio-group.component';

@Component({
  selector     : '[nz-radio]',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <span [ngClass]="_classMap">
      <span [ngClass]="_innerPrefixCls"></span>
      <input type="radio" [ngClass]="_inputPrefixCls" [(ngModel)]="nzChecked" (focus)="nzFocus()" (blur)="nzBlur()">
    </span>
    <ng-content></ng-content>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-radio-group {
  display: inline-block;
  font-size: 14px;
}
.ant-radio-wrapper {
  font-size: 14px;
  display: inline-block;
  position: relative;
  white-space: nowrap;
  margin-right: 8px;
  cursor: pointer;
}
.ant-radio {
  white-space: nowrap;
  outline: none;
  display: inline-block;
  position: relative;
  line-height: 1;
  vertical-align: text-bottom;
  cursor: pointer;
}
.ant-radio-wrapper:hover .ant-radio .ant-radio-inner,
.ant-radio:hover .ant-radio-inner,
.ant-radio-focused .ant-radio-inner {
  border-color: #00b8a9;
}
.ant-radio-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #00b8a9;
  content: '';
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}
.ant-radio:hover:after,
.ant-radio-wrapper:hover .ant-radio:after {
  visibility: visible;
}
.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 14px;
  height: 14px;
  border-width: 1px;
  border-style: solid;
  border-radius: 14px;
  border-color: #d9d9d9;
  background-color: #fff;
  transition: all 0.3s;
}
.ant-radio-inner:after {
  position: absolute;
  width: 6px;
  height: 6px;
  left: 3px;
  top: 3px;
  border-radius: 4px;
  display: table;
  border-top: 0;
  border-left: 0;
  content: ' ';
  background-color: #00b8a9;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-radio-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.ant-radio-checked .ant-radio-inner {
  border-color: #00b8a9;
}
.ant-radio-checked .ant-radio-inner:after {
  transform: scale(1);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-radio-disabled .ant-radio-inner {
  border-color: #d9d9d9 !important;
  background-color: #f7f7f7;
}
.ant-radio-disabled .ant-radio-inner:after {
  background-color: #ccc;
}
.ant-radio-disabled .ant-radio-input {
  cursor: not-allowed;
}
.ant-radio-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
span.ant-radio + * {
  padding-left: 8px;
  padding-right: 8px;
}
.ant-radio-button-wrapper {
  margin: 0;
  height: 30px;
  line-height: 28px;
  color: #666;
  display: inline-block;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-left: 0;
  background: #fff;
  padding: 0 16px;
  position: relative;
}
.ant-radio-button-wrapper a {
  color: #666;
}
.ant-radio-button-wrapper > .ant-radio-button {
  margin-left: 0;
  display: block;
  width: 0;
  height: 0;
}
.ant-radio-group-large .ant-radio-button-wrapper {
  height: 34px;
  line-height: 32px;
}
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 28px;
  line-height: 26px;
  padding: 0 12px;
}
.ant-radio-group-small .ant-radio-button-wrapper:first-child {
  border-radius: 2px 0 0 2px;
}
.ant-radio-group-small .ant-radio-button-wrapper:last-child {
  border-radius: 0 2px 2px 0;
}
.ant-radio-button-wrapper:not(:first-child)::before {
  content: "";
  display: block;
  top: 0;
  left: -1px;
  width: 1px;
  height: 100%;
  position: absolute;
  background-color: #d9d9d9;
}
.ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px;
  border-left: 1px solid #d9d9d9;
}
.ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0;
}
.ant-radio-button-wrapper:first-child:last-child {
  border-radius: 4px;
}
.ant-radio-button-wrapper:hover,
.ant-radio-button-wrapper-focused {
  color: #00b8a9;
  position: relative;
}
.ant-radio-button-wrapper .ant-radio-inner,
.ant-radio-button-wrapper input[type="checkbox"],
.ant-radio-button-wrapper input[type="radio"] {
  opacity: 0;
  filter: alpha(opacity=0);
  width: 0;
  height: 0;
}
.ant-radio-button-wrapper-checked {
  background: #fff;
  border-color: #00b8a9;
  color: #00b8a9;
  box-shadow: -1px 0 0 0 #00b8a9;
  z-index: 1;
}
.ant-radio-button-wrapper-checked::before {
  background-color: #00b8a9 !important;
  opacity: 0.1;
}
.ant-radio-button-wrapper-checked:first-child {
  border-color: #00b8a9;
  box-shadow: none !important;
}
.ant-radio-button-wrapper-checked:hover {
  border-color: #3dc9be;
  box-shadow: -1px 0 0 0 #3dc9be;
  color: #3dc9be;
}
.ant-radio-button-wrapper-checked:active {
  border-color: #009e94;
  box-shadow: -1px 0 0 0 #009e94;
  color: #009e94;
}
.ant-radio-button-wrapper-disabled {
  border-color: #d9d9d9;
  background-color: #f7f7f7;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}
.ant-radio-button-wrapper-disabled:first-child,
.ant-radio-button-wrapper-disabled:hover {
  border-color: #d9d9d9;
  background-color: #f7f7f7;
  color: rgba(0, 0, 0, 0.25);
}
.ant-radio-button-wrapper-disabled:first-child {
  border-left-color: #d9d9d9;
}
.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: #fff;
  background-color: #e6e6e6;
  border-color: #d9d9d9;
  box-shadow: none;
}
@keyframes antRadioEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
`
  ]
})
export class NzRadioComponent implements OnInit {
  private _checked = false;
  private _disabled = false;
  private _focused = false;
  _el: HTMLElement;
  _classMap;
  _value: string;
  _prefixCls = 'ant-radio';
  _innerPrefixCls = `${this._prefixCls}-inner`;
  _inputPrefixCls = `${this._prefixCls}-input`;

  @Input()
  @HostBinding('class.ant-radio-wrapper-checked')
  set nzChecked(value: boolean) {
    this._checked = toBoolean(value);
    this.setClassMap();
  }

  get nzChecked(): boolean {
    return this._checked;
  }

  @Input()
  get nzValue(): string {
    return this._value;
  }

  set nzValue(value: string) {
    if (this._value === value) {
      return;
    }
    this._value = value;
  }

  @Input()
  @HostBinding('class.ant-radio-wrapper-disabled')
  set nzDisabled(value: boolean) {
    this._disabled = toBoolean(value);
    this.setClassMap();
  }

  get nzDisabled(): boolean {
    return this._disabled;
  }

  @HostListener('click', [ '$event' ])
  onClick(e: MouseEvent): void {
    e.preventDefault();
    if (!this._disabled) {
      this._checked = true;
      this.setClassMap();
      this._nzRadioGroup.selectRadio(this);
    }
  }

  nzFocus(): void {
    this._focused = true;
    this.setClassMap();
  }

  nzBlur(): void {
    this._focused = false;
    this.setClassMap();
    this._nzRadioGroup.onTouched();
  }

  setClassMap(): void {
    this._classMap = {
      [this._prefixCls]              : true,
      [`${this._prefixCls}-checked`] : this._checked,
      [`${this._prefixCls}-focused`] : this._focused,
      [`${this._prefixCls}-disabled`]: this._disabled
    };
  }

  constructor(private _elementRef: ElementRef, public _renderer: Renderer2, public _nzRadioGroup: NzRadioGroupComponent) {
    this._el = this._elementRef.nativeElement;
  }

  ngOnInit(): void {
    this._nzRadioGroup.addRadio(this);
    this._renderer.addClass(this._el, `${this._prefixCls}-wrapper`);
    this.setClassMap();
  }
}
